export function getReferrerNameFromReferralCode({
  referralCode,
}: {
  referralCode?: string | null
}) {
  if (!referralCode) {
    return 'your friend'
  }
  const match = new RegExp('INVITE(.*)(.{6})$').exec(referralCode)
  if (match) {
    const name = match[1].toLowerCase()
    return name.charAt(0).toUpperCase() + name.slice(1)
  }
  return 'your friend'
}
